import Api from './api';
import { UserDTO } from './model';

// TODO: #3059 - Refactor 'any'
/* eslint-disable @typescript-eslint/no-explicit-any */
export default class ApiUser extends Api {
    public static getMyUserProfile(): Promise<UserDTO> {
        return this.axios.get('/v1/user', { cache: false }).then((res) => {
            const profile: UserDTO = res.data;
            return profile;
        });
    }

    public static signup(
        email: string,
        password: string,
        name: string,
        firstName: string,
        lastName: string,
        newsletterSignUp: boolean
    ): Promise<string> {
        const data = {
            email: email,
            password: password,
            name: name,
            firstName: firstName,
            lastName: lastName,
            newsletterSignUp: newsletterSignUp,
        };
        return this.axios.post('/v1/user', data).then((res) => {
            return res.data.idToken;
        });
    }

    public static deleteUser(id: any): Promise<string> {
        return this.axios.delete('/v1/user', id).then((res) => {
            return res.data;
        });
    }

    public static requestPasswordResetPromise(email: string): Promise<any> {
        return this.axios.get(`/v1/user/reset_password?email=${encodeURIComponent(email)}`, { cache: false });
    }

    public static resetPasswordPromise(id: string, email: string, password?: string): Promise<any> {
        return this.axios.post('/v1/user/reset_password', {
            email: email,
            password: password,
            id: id,
        });
    }

    public static getUserProfile(userId: string): Promise<UserDTO> {
        return this.axios.get('/v1/users/' + userId, { cache: true }).then((res) => {
            return res.data;
        });
    }
}
